import axios from "axios";
import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import messages from '../statics/messages.json';
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("site") || "");
  const navigate = useNavigate();
  const loginAction = async (data) => {
    try {
      debugger

      // const isLocal = window.location.hostname === "localhost";
      // const port = isLocal ? 8085 : "";
      // const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;
      // const url = `${contextPath}/api/login`;

      // // const contextPath = `${window.location.protocol}//${window.location.hostname}:${messages.node_server_port}`;
      // const contextPath = `${window.location.protocol}//${window.location.hostname}`;

      // Check if running locally
      const isLocal = window.location.hostname === "localhost";

      // Get port from config for local, empty for production
      const port = isLocal ? messages.node_server_port : "";

      // Build the base URL
      const contextPath = `${window.location.protocol}//${window.location.hostname}${port ? `:${port}` : ''}`;

      const url = `${contextPath}/api/login`;
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(data),
      }, {
        withCredentials: true, // ✅ very important
      });


      // const res = {
      //   message : "success",
      //   token : "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJiYWx1IiwiaWF0IjoxNzI3NzU0MzIwLCJleHAiOjE3Mjc3NTYxMjB9.Tn9d9v_M5rV3UFV-BdIQZ6lsch2W0xHgap5Ot3ORFQw",
      //   userName : "balu"
      // }

      const res = await response.json();
      if (res.token) {
        setUser(res.user);
        setToken(res.token);
        localStorage.setItem("site", res.token);
        localStorage.setItem("userEmail", res.user);
        navigate("/dashboard");
        return;
      } else {
        if (res.message)
          alert(res.message)
        else
          alert("something went wrong");
      }
      throw new Error(res.message);
    } catch (err) {
      console.error(err);
    }
  };




  const logOut = () => {
    setUser(null);
    setToken("");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("site");
    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ token, user, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );

};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};